<template>
  <div class="row filter-toolbar" v-if="activeLibrary && activeLibrary.id == 'MINE'">
    <search-bar />
    <div class="col-md-3 text-left">
      <a @click="openTagsModal">{{ $t('tags.button_open_modal') }}</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchBar from './SearchBar.vue';
import { debounce } from 'lodash';

export default {
  name: 'FilterToolbar',
  computed: {
    ...mapGetters([
      'activeLibrary'
    ]),
  },
  components: {
    SearchBar
  },
  methods: {
    openTagsModal: debounce(function() {
      this.$emit('customer-tags');
    }, 500)
  }
};
</script>

<style scoped>
  .filter-toolbar {
    margin-bottom: 20px;
  }
  .filter-toolbar a {
    line-height: 34px;
    cursor: pointer;
  }
</style>

